import React from "react";

import AllRoutes from "./routes/Routes";

//import { configureFakeBackend } from "./helpers";


// For Default import Default.scss
import "./assets/scss/Default.scss";

// For Saas import Saas.scss
// import './assets/scss/Saas.scss';

// For Modern demo import Modern.scss
// import './assets/scss/Modern.scss';

// For Creative demo import Creative.scss
// import "./assets/scss/Creative.scss";

// For Purple demo import Purple.scss
// import './assets/scss/Purple.scss';

// For Material demo import Material.scss
// import './assets/scss/Material.scss';


// Other
import "./assets/scss/Landing.scss";
import "./assets/scss/Icons.scss";
import "react-ladda-button/dist/ladda-themeless.min.css";
import "react-toastify/dist/ReactToastify.css";

// configure fake backend
//configureFakeBackend();

//query client
import { QueryClientProvider } from "react-query";
import { queryClient } from "./helpers/queryClient";
import { ToastContainer } from "react-toastify";

// Amazon Chime SDK Component Library
import { ThemeProvider } from 'styled-components';
import {
  MeetingProvider,
  lightTheme,
  GlobalStyles,
  LocalAudioOutputProvider,
} from 'amazon-chime-sdk-component-library-react';
import RouteAnalytics from './analytics/usePageTracking';
import ErrorBoundary from "./components/ErrorBoundary";

const App = () => {

  return (
    <>
      {/* A render error used to white-screen the operator with no signal at all: this app had no boundary, so the crash was invisible to everyone including us. Counts the error CLASS only - message and stack quote record values (ANALYTICS.md B4). */}
      <ErrorBoundary>
        <ThemeProvider theme={lightTheme}>
          <GlobalStyles />
          <QueryClientProvider client={queryClient}>
            <MeetingProvider>
              <LocalAudioOutputProvider>
                <React.Fragment>
                  {/* GA4 SPA page-view + identity tracking (inside the Router) */}
                  <RouteAnalytics />

                  <AllRoutes />

                  <ToastContainer />
                </React.Fragment>
              </LocalAudioOutputProvider>
            </MeetingProvider>
          </QueryClientProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </>
  );
};

export default App;
